import { jsx as r } from "react/jsx-runtime";
const a = ({
  onClick: t,
  children: o,
  type: e = "button",
  ...n
}) => /* @__PURE__ */ r("button", { type: e, onClick: t, ...n, children: o });
export {
  a as default
};
